;(function() {
  'use strict'

  angular.module('core.input', [])
})()
